import { useNotifications } from '@/hooks/useNotifications';
import { Notification } from '@/types/notification.types';
import CloseIcon from '@mui/icons-material/Close';
import { Alert, Collapse, IconButton } from '@mui/material';
import { memo } from 'react';

interface IProps {
  notification: Notification;
}

export const NotificationItem = memo(({ notification }: IProps) => {
  const { removeNotification } = useNotifications();

  return (
    <Collapse in>
      <Alert
        severity={notification.type}
        sx={{
          borderRadius: 3,
          minWidth: 320,
          maxWidth: 600,
          boxShadow: 3,
        }}
        action={
          <IconButton size='small' onClick={() => removeNotification(notification.id)}>
            <CloseIcon fontSize='small' />
          </IconButton>
        }
      >
        {notification.content}
      </Alert>
    </Collapse>
  );
});
